import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/tokens.css';
import './index.css';
import './styles/utilities.css';
import './styles/ui.css';
import './styles/pages.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');

// react-snap prerenders static HTML at build time; hydrate it when present,
// otherwise do a normal client render (dev + non-prerendered builds).
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}

// Web Vitals are forwarded to analytics in src/lib/analytics (wired in Phase 2).
reportWebVitals();
